import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCloudy",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, i, _, f, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--cloudy"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Cloudy",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.163 4.015a4 4 0 0 0-3.319-.96 2.25 2.25 0 0 1 4.072.582.5.5 0 0 0 .48.363H9.5a1 1 0 0 1 1 1 .5.5 0 0 0 1 0 2 2 0 0 0-2-2h-.75a3.251 3.251 0 0 0-6.159.485A4 4 0 0 0 4.5 11h4.25a2.75 2.75 0 1 0 0-5.5h-.541a4 4 0 0 0-1.046-1.485Zm-2.138.031A3 3 0 1 0 4.5 10h4.25a1.75 1.75 0 1 0 0-3.5h-.895a.5.5 0 0 1-.48-.357 3 3 0 0 0-2.35-2.097Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const g = /* @__PURE__ */ s(c, [["render", m]]);
export {
  g as default
};
//# sourceMappingURL=cloudy.js.map
